import React from 'react';
import { TripContext } from '../components/TripProvider';
export function useTrip() {
    return React.useContext(TripContext);
}
